export default __webpack_public_path__ + "static/media/agrmntSprite-ef2c3f4ef4cbad065d2dc1ad4b5041b1.png";